export function createTipGorivaPredicate(tipGoriva) {
  return cjenik => cjenik.gorivo.vrsta_goriva.tip_goriva_id === +tipGoriva;
}
